import { MAX_INPUT_HEIGHT } from 'src/constants/input';
import { Theme } from '@mui/material';
import { GRAY_SECONDARY, WHITE } from 'src/global/theme/colors';
import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()((theme: Theme) => {
  return {
    button: {
      padding: '6px 31px',
      height: MAX_INPUT_HEIGHT,
      background: theme.palette.secondary.main,
      borderRadius: '8px',
      color: WHITE,
      fontWeight: 400,
      fontSize: '15px',
      lineHeight: '22px',
      textTransform: 'none',
      '&:hover': {
        background: theme.palette.secondary.light,
        color: WHITE
      }
    },
    isButtonLoading: {
      backgroundColor: `${GRAY_SECONDARY} !important`
    }
  };
});
